import styled from "@emotion/styled/macro";
import GenericError from "../GenericError/GenericError";

export const FullScreenGenericError = styled(GenericError)`
  height: 100%;
`;
